/**
 * Where a lead's person stands among the enrollments — the words and colours
 * for the "Înscriere" column and the call-list filters. Pure, so tested.
 *
 * The server sends `enrollment_match` per lead: `{stage, matched_by, …}` or
 * null. A partner looking at somebody else's enrollment gets the stage only.
 */

export const STAGE = {
  paid: { label: "Plătit", cls: "bg-[#519872]/15 text-[#2f6b50]" },
  confirmed: { label: "Confirmat", cls: "bg-[#519872]/15 text-[#2f6b50]" },
  pending: { label: "Înscris, neplătit", cls: "bg-[#FDE68A]/60 text-[#8a6a1a]" },
  abandoned: { label: "A abandonat plata", cls: "bg-[#FDBA74]/30 text-[#92400E]" },
  gone: { label: "Anulat / rambursat", cls: "bg-[#EDEEF0] text-[#6B7280]" },
};

export const PHONE_MATCH = { label: "Posibil aceeași persoană", cls: "bg-[#3F8EBA]/15 text-[#1f5d80]" };

/** The call list, in the order a caller works through it. */
export const ENROLLMENT_FILTERS = [
  { id: "none", label: "De sunat", hint: "Fără nicio înscriere" },
  { id: "started", label: "A început, n-a plătit", hint: "Înscriere neplătită, abandonată sau cu plată eșuată" },
  { id: "converted", label: "Deja plătiți", hint: "Nu mai trebuie sunați pentru vânzare" },
  { id: "phone_only", label: "Posibil dubluri", hint: "Același telefon, alt email" },
];

/** `{label, cls, detail}` for one lead's match, or null when there is none. */
export function matchBadge(match) {
  if (!match?.stage) return null;
  const stage = STAGE[match.stage] || { label: match.stage, cls: "bg-[#EDEEF0] text-[#373A45]" };
  if (match.matched_by === "phone") {
    return { ...PHONE_MATCH, detail: `${stage.label} · alt email, același telefon` };
  }
  const bits = [];
  if (match.group_name) bits.push(match.group_name);
  if (match.enrollments > 1) bits.push(`${match.enrollments} înscrieri`);
  return { ...stage, detail: bits.join(" · ") };
}

/** Small ticks shown under the badge (owner/admin only — the server omits them otherwise). */
export function matchTicks(match) {
  if (!match || match.matched_by === "phone") return [];
  const out = [];
  if (match.ministry_done) out.push("dosar ✓");
  if (match.contract_signed) out.push("contract ✓");
  return out;
}
